import { gpHome } from '../app';
import { IStorageService } from '../../app-common/services/local-storage-service';
import { IAuthorisationCheckerService, IAuthorisationCheckerService_serviceName, IAuthorisationStatus } from '../../app-common/services/authorisation-checker-with-caching-service';
import { ILogglyService } from '../../app-common/services/jsloggly-service';
import { LoginService, ILoginResponse, ILoginInputs } from '../../app-common/services/login-service';

gpHome.factory('authService', [
        '$http',
        '$q',
        'gpLocalStorageService',
        IAuthorisationCheckerService_serviceName,
        'gpLogglyService',
        'gpLoginService',
        function (
            $http: ng.IHttpService,
            $q: ng.IQService,
            storage: IStorageService,
            authChecker: IAuthorisationCheckerService,
            gpLogglyService: ILogglyService,
            gpLoginService: LoginService) {

            const serviceBase = __gameplan_service_url || 'http://localhost/';

            return new AuthService(serviceBase, $http, $q, storage, authChecker, gpLogglyService, gpLoginService);

        }]);

    export interface IRegisterInputs {
        email: string;
        password: string;
        confirmPassword: string;
        name: string;
        company: string;
        comments: string;
    }

    interface EmailAndToken {
        email: string;
        token: string;
    }

    export interface IAuthService {
        resetCheckedStatus(): void;
        checkAuthorisationIfNeeded(): ng.IPromise<IAuthorisationStatus>;
        authorisationChanged(callback: ((authStatus: IAuthorisationStatus) => void)): void;
        login(loginData: ILoginInputs): ng.IPromise<ILoginResponse>;
        logOut(): void;

        tryToRegisterNewUserSkipInvitation(registration: IRegisterInputs): ng.IPromise<{}>;
    }

    class AuthService implements IAuthService {

        constructor(public serviceBase: string,
            public $http: ng.IHttpService,
            public $q: ng.IQService,
            public storage: IStorageService,
            private authChecker: IAuthorisationCheckerService,
            private gpLogglyService: ILogglyService,
            private gpLoginService: LoginService
        ) {
        }

        public tryToRegisterNewUserSkipInvitation(registration: IRegisterInputs): ng.IPromise<any> {
            var $http = this.$http;

            this.logOut();

            var request = $http.post<any>(this.serviceBase + 'api/accounts/create', registration);

            var result = this.$q.defer();

            request.then(response => {
                result.resolve(response.data);
            }).catch(err => { });

            request.catch(reason => result.reject(reason));

            return result.promise;
        }

        public login(loginData: ILoginInputs): ng.IPromise<ILoginResponse> {

            return this.gpLoginService.login(loginData);

        }

        public logOut() {

            return this.gpLoginService.logOut();

        }

        public resetCheckedStatus(): void {
            this.authChecker.resetCheckedStatus();
        }

        public checkAuthorisationIfNeeded(): ng.IPromise<IAuthorisationStatus> {
            return this.authChecker.checkAuthorisationIfNeeded();
        }

        public authorisationChanged(callback: ((authStatus: IAuthorisationStatus) => void)): void {
            this.authChecker.authorisationChanged(callback);
        }
    }
